<div class="float-icon" *ngIf="mobilePhone">
  <a (click)="redirectExternalPage()" [href]="contactInfo['whatsapp-url'] + mobilePhone" target="_blank">
    <img class="icon" src="assets/images/float-icon.svg" [alt]="contactInfo['mobile-phone']">
  </a>
</div>
